export enum DisplayTarget {
  bottom = 1, window = 2
}

